import styled from 'styled-components/macro';

export const Container = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: ${({ theme }) => theme.colors.background[1]};
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
`;
